var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 7.046 13.156"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "icon-facebook",
  d: "M8.194,7.4l.365-2.381H6.275V3.474A1.19,1.19,0,0,1,7.617,2.188H8.656V.161A12.666,12.666,0,0,0,6.812,0,2.907,2.907,0,0,0,3.7,3.2V5.019H1.609V7.4H3.7v5.756H6.275V7.4Z",
  transform: "translate(-1.609)"
})));
export default SvgIconFacebook;